/**
 * @fileoverview ハッシュリンクのスクロール処理を行うコンポーネント
 */
import { useEffect } from "react";

/**
 * ハッシュリンクのスクロール処理を行う
 * @returns {null} null
 */
const ScrollToHash: React.FC = () => {
  useEffect(() => {
    //初回マウント時にハッシュを取得
    const hash = window.location.hash;

    // ハッシュが存在する場合
    if (hash) {
      // ハッシュから#を取り除いて要素を取得
      const element = document.getElementById(hash.substring(1));
      if (element) {
        // スムーズにスクロール
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []); // 初回マウント時にだけ実行

  return null; // このコンポーネントは何もレンダリングしない
};

export default ScrollToHash;
